export default __webpack_public_path__ + "static/media/black-chevron-left.6a48be0f.svg";